import { withCache } from '@ngneat/cashew';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { environment } from '@environments/environment';

import { API } from '@models/API';

import { platformAPI } from '@services/API/endpoints';

/** Cache entry of `/operations/filters`, shared by every reader of that response. */
export const FILTERS_CACHE_KEY = 'filters';

@Injectable({
  providedIn: 'root',
})
export class FiltersService {
  private http = inject(HttpClient);
  public cacheKey = FILTERS_CACHE_KEY;

  get(loaderOptIn: boolean | string = true) {
    const url = platformAPI.trusts().operations.filters;
    const options = {
      headers: new HttpHeaders({
        'Loader-Opt-In': `${loaderOptIn}`,
        'Auth-Opt-In': 'true',
      }),
      context: withCache({
        ttl: environment.CACHE_LIFETIME!,
        key: this.cacheKey,
      }),
    };
    return this.http.get<API.Trusts.Operations.Filter.Response>(url, options);
  }
}
